module.exports = __webpack_public_path__ + "img/thankParticipating.0fa91139.png";